import script from "./TeacherRegister.vue?vue&type=script&setup=true&lang=ts"
export * from "./TeacherRegister.vue?vue&type=script&setup=true&lang=ts"

import "./TeacherRegister.vue?vue&type=style&index=0&id=475d7b84&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-475d7b84"]])

export default __exports__